"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var AppIntegrations_module_css_1 = __importDefault(require("./AppIntegrations.module.css"));
var TypeGuards_1 = require("@/functions/TypeGuards");
var AppIntegrationResourceSettings = function (props) {
    var _a, _b, _c;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    // Change handlers
    var onIntegrationResourceChange = function (event) {
        if (event.target.value !== "") {
            props.resourceEditorData.template = event.target.value;
            props.resourceEditorData.variables = {};
            props.appIntegrationTemplate.definition.script.resources[props.resourceEditorData.template].settings.map(function (setting) {
                var defaultValue = setting.getDefaultValue();
                if ((0, TypeGuards_1.isPrimitive)(defaultValue)) {
                    props.resourceEditorData.variables[setting.key] = defaultValue;
                }
            });
        }
        else {
            props.resourceEditorData.template = undefined;
        }
        props.onResourceChangedHandler(props.identifier, props.resourceEditorData);
    };
    var onIntegrationNameChange = function (event) {
        props.resourceEditorData.name = event.target.value;
        props.onResourceChangedHandler(props.identifier, props.resourceEditorData);
    };
    var onSettingsChangedHandler = function (e, key) {
        var _a, _b;
        var data_value;
        var propKey;
        var setting;
        if (key) {
            propKey = key;
            setting = (_a = props.appIntegrationResourceTemplate) === null || _a === void 0 ? void 0 : _a.settings.find(function (setting) { return setting.key === propKey; });
            data_value = e;
        }
        else {
            var event_1 = e;
            propKey = event_1.target.dataset.key;
            setting = (_b = props.appIntegrationResourceTemplate) === null || _b === void 0 ? void 0 : _b.settings.find(function (setting) { return setting.key === propKey; });
            if (setting instanceof q_play_core_1.BooleanSetting) {
                data_value = event_1.target.checked;
            }
            else {
                data_value = event_1.target.value;
            }
        }
        switch (propKey) {
            case "size":
                // eslint-disable-next-line no-case-declarations
                var value = setting.hydrate(data_value);
                if ((0, TypeGuards_1.isPrimitive)(value))
                    props.resourceEditorData.variables[propKey] = value;
                if ((props.resourceEditorData.variables[propKey] + "").includes("x")) {
                    var size = (props.resourceEditorData.variables[propKey] + "").split("x");
                    props.resourceEditorData.variables["width"] = parseInt(size[0]);
                    props.resourceEditorData.variables["height"] = parseInt(size[1]);
                }
                break;
            default:
                if (setting instanceof q_play_core_1.BooleanSetting) {
                    props.resourceEditorData.variables[propKey] = data_value;
                }
                else {
                    // eslint-disable-next-line no-case-declarations
                    var value_1 = setting.hydrate(data_value);
                    if ((0, TypeGuards_1.isPrimitive)(value_1))
                        props.resourceEditorData.variables[propKey] = value_1;
                }
                break;
        }
        props.onResourceChangedHandler(props.identifier, props.resourceEditorData);
    };
    // Create mandatory settings.
    var resourceName = new q_play_core_1.StringSetting("resource-name", t("Name"));
    var resourceSelect = new q_play_core_1.SelectSetting("resource-select", "Resource");
    var options = [];
    options.push({ label: "Empty", value: "" });
    Object.keys(props.appIntegrationTemplate.definition.script.resources).map(function (key) {
        options.push({ label: props.appIntegrationTemplate.definition.script.resources[key].name, value: key });
    });
    resourceSelect.options = options;
    var primaryColumnSettings = (_a = props.appIntegrationResourceTemplate) === null || _a === void 0 ? void 0 : _a.settings.filter(function (setting) {
        return setting.section !== "secondary" && setting.isVisible(props.resourceEditorData.variables);
    });
    var secondaryColumnSettings = (_b = props.appIntegrationResourceTemplate) === null || _b === void 0 ? void 0 : _b.settings.filter(function (setting) {
        return setting.section === "secondary" && setting.isVisible(props.resourceEditorData.variables);
    });
    return (react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["resource-settings-tab-content"], style: { minHeight: "265px" }, "data-cy": "resourceSettingsTabContent" },
        react_1.default.createElement("div", { style: { marginTop: "1rem", width: "100%" } },
            react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } },
                t("Settings"),
                ":"),
            react_1.default.createElement("div", { style: { display: "flex" } },
                react_1.default.createElement("div", { style: { width: "50%" } },
                    react_1.default.createElement(q_play_components_1.SettingsComponent, { key: resourceSelect.key, value: (_c = props.resourceEditorData.template) !== null && _c !== void 0 ? _c : "", disabled: false, setting: resourceSelect, onChange: onIntegrationResourceChange }),
                    react_1.default.createElement(q_play_components_1.SettingsComponent, { key: resourceName.key, value: props.resourceEditorData.name, disabled: false, setting: resourceName, onChange: onIntegrationNameChange }),
                    primaryColumnSettings && primaryColumnSettings.map(function (setting) {
                        return (react_1.default.createElement(q_play_components_1.SettingsComponent, { key: setting.key, value: props.resourceEditorData.variables[setting.key], disabled: setting.isDisabled(props.resourceEditorData.variables), setting: setting, onChange: onSettingsChangedHandler }));
                    })),
                react_1.default.createElement("div", { style: { width: "50%", marginLeft: "50px" } }, secondaryColumnSettings && secondaryColumnSettings.map(function (setting) {
                    return (react_1.default.createElement(q_play_components_1.SettingsComponent, { key: setting.key, value: props.resourceEditorData.variables[setting.key], disabled: setting.isDisabled(props.resourceEditorData.variables), setting: setting, onChange: onSettingsChangedHandler }));
                }))))));
};
exports.default = AppIntegrationResourceSettings;
